import styles from '../assets/css/gapsy-dashboard.module.css';
import React, { useState, useRef, useEffect } from "react";
import { BsBellFill } from 'react-icons/bs';
import { useNavigate, useLocation } from 'react-router-dom';
import axios from 'axios';
import { NotifyApi, LogoutApi, bellIconClick, pendingnotify } from "../components/ApiProperty";
import Offcanvas from 'react-bootstrap/Offcanvas';

const Header = () => {
  const userName = localStorage.getItem('username');
  const userRole = localStorage.getItem('userRole');
  const lastLogin = localStorage.getItem('lastLogin');
  const department = sessionStorage.getItem('dept');
  const profileRef = useRef(null);

  const [showOffcanvas, setShowOffcanvas] = useState(false);
  const [notifications, setNotifications] = useState([]);
  const [notificationCount, setNotificationCount] = useState(0);
  const [isAuthenticated, setIsAuthenticated] = useState(false); // New state to track authentication status
  const [superuserRole, setSuperuserRole] = useState(localStorage.getItem("userRole") || "Admin")
  const originalRole = localStorage.getItem("originalUserRole");

  const navigate = useNavigate();
  const username = localStorage.getItem('username');
  const user = username ? { username } : null;

  const location = useLocation();
  let csrfToken = sessionStorage.getItem("tokenizedSession");

  const userId = localStorage.getItem('userid');

  const displayDepartment =
    userId === "10034"
      ? "Risk"
      : department === "Finance"
        ? "Finance and Planning"
        : department;

  const displayRole =
    userId === "10159" && userRole === "Admin"
      ? "Risk Officer"
      : userId === "10034" && userRole === "Superuser"
        ? "Risk SuperUser"
        : userRole === "Admin"
          ? "Manager"
          : userRole;

  useEffect(() => {

    if (!userId && location.pathname !== '/ForgotPassword') {
      navigate('/');
    } else {
      setIsAuthenticated(true);
      fetchNotifications();
    }
  }, [navigate, location]);


  useEffect(() => {
    const userName = localStorage.getItem('username');
    const userRole = localStorage.getItem('userRole');
    const lastLogin = localStorage.getItem('lastLogin');
    const department = sessionStorage.getItem('dept');

    if (!userName || !userRole || !lastLogin || !department) {
      navigate('/notfound', {
        state: {
          message: "Session expired or invalid login detected. You are being logged out. This will also end any other active sessions.",
          found: "401 User is not authenticated"
        }
      });
    }
  }, []);

  // Handle clicking the bell icon
  const handleBellClick = async () => {
    if (!showOffcanvas) {
      // Only fetch if opening
      try {
        await fetchNotifications();
        const config = {
          params: { "userId": localStorage.getItem('userid'), "activeStatus": 'Y' },
          headers: {
            "x-csrf-token": csrfToken
          },
          withCredentials: true
        };
        await axios.post(bellIconClick, {}, config);
        setNotificationCount(0);
      } catch (error) {
        console.error('Error updating notification status', error);
      }
    }
    setShowOffcanvas(!showOffcanvas); // Toggle visibility
  };

  const handleClose = () => {
    setShowOffcanvas(false);
  };

  const fetchNotifications = async () => {
    try {
      const config = {
        headers: {
          "userId": localStorage.getItem('userid'),
          "x-csrf-token": csrfToken
        },
        withCredentials: true
      };
      const response = await axios.post(NotifyApi, {}, config);
      const fetchedNotifications = response.data || {};
      setNotifications(fetchedNotifications.notifications || []);
      setNotificationCount(fetchedNotifications.countOfNewNotifications || 0);
    } catch (error) {
      console.error('Error fetching notifications:', error);
    }
  };


  // const handleLogout = async () => {
  //   try {
  //     await axios.post(LogoutApi, {}, {
  //       headers: {
  //         "userId": localStorage.getItem('userid'),
  //         "x-csrf-token": csrfToken
  //       },
  //       withCredentials: true
  //     });
  //     localStorage.clear();
  //     sessionStorage.clear();
  //     navigate("/");
  //   } catch (error) {
  //     console.error(error);
  //     alert("Failed to logout");
  //   }
  // };

  const handleLogout = async () => {
    try {
      await axios.post(LogoutApi, {}, {
        headers: {
          userId: localStorage.getItem("userid"),
          "x-csrf-token": csrfToken
        },
        withCredentials: true
      });

      // Preserve these two localStorage keys
      const excelTitle = localStorage.getItem("excelTitle");
      const ratingColors = localStorage.getItem("ratingColors");

      localStorage.clear();

      if (excelTitle !== null) {
        localStorage.setItem("excelTitle", excelTitle);
      }

      if (ratingColors !== null) {
        localStorage.setItem("ratingColors", ratingColors);
      }

      // Clear all session storage
      sessionStorage.clear();

      navigate("/");
    } catch (error) {
      console.error(error);
      alert("Failed to logout");
    }
  };

  function getInitials(name) {
    if (!name) return '';
    const parts = name.trim().split(' ');
    let initials = '';

    if (name.length === 1) {
      // If username length is 1, just take that letter
      initials = name[0].toUpperCase();
    } else {
      // Otherwise, take first two characters of the username string (not words)
      initials = name.substring(0, 2).toUpperCase();
    }
    return initials;
  }

  function Avatar({ userName }) {
    const initials = getInitials(userName);

    const avatarStyle = {
      width: '32px',
      height: '32px',
      borderRadius: '50%',
      backgroundColor: '#dddddd', // Bootstrap primary blue or any color you want
      color: '#32606a',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      fontWeight: '600',
      fontSize: '14px',
      userSelect: 'none',
    };

    return <div style={avatarStyle}>{initials}</div>;
  }
  // Only for Super User
  const handleRoleChange = (role) => {
    localStorage.setItem("userRole", role);
    setSuperuserRole(role); // assuming you're using useState to track role

    switch (role) {
      case "Admin":
        navigate("/gapsyAdashboard");
        break;
      case "Maker":
        navigate("/gapsyMdashboard");
        break;
      case "Checker":
        navigate("/gapsyCdashboard");
        break;
      default:
        break;
    }
  };


  return (
    <header className={`d-flex justify-content-between align-items-center px-4 shadow text-white ${styles.mainHeader}`}>
      <h5 className={`mb-0 d-flex align-items-center ${styles.h5LogoFont}`}>
        Gapsphere.AI
      </h5>
      {/* <h5 className="mb-0 d-flex align-items-center">
        <img
          src={require('../assets/images/anb-logo1.png')}
          alt="ANB Logo"
          style={{
            height: "40px",
            width: "auto",
            objectFit: "contain"
          }}
        />
      </h5> */}

      <div className="d-flex align-items-center">
        <div className="position-relative me-4" style={{ cursor: 'pointer' }} onClick={handleBellClick}>
          <BsBellFill className="fs-5 text-white" />
          {notificationCount > 0 && (
            <span className="position-absolute top-0 start-100 translate-middle badge bg-danger small">
              {notificationCount}
            </span>
          )}

          {/* Notification Offcanvas */}
          <Offcanvas
            show={showOffcanvas}
            onHide={handleClose}
            placement="end"
            className={styles.notificationOffcanvas}
          >
            <Offcanvas.Header className="pb-2">
              <Offcanvas.Title className="fs-6">
                Notifications
                {notificationCount > 0 && <span className="ms-2 small">({notificationCount})</span>}
              </Offcanvas.Title>
              <button
                type="button"
                className="btn-close small"
                onClick={handleClose}
                aria-label="Close"
              />
            </Offcanvas.Header>
            <Offcanvas.Body className="pt-2 overflow-auto" style={{ scrollbarWidth: 'thin' }}>
              {notifications.filter(
                (notification) => notification.CompletedActivity
              ).length > 0 ? (
                notifications
                  .filter((notification) => notification.CompletedActivity)
                  .map((notification, index) => {
                    // Enhanced helper function to process the table name
                    const formatTableName = (name) => {
                      // Remove everything before the first underscore (if underscore exists)
                      const parts = name.split('_');
                      const withoutPrefix = parts.length > 1 ? parts.slice(1).join('_') : name;

                      // Replace all remaining underscores with spaces
                      const withSpaces = withoutPrefix.replace(/_/g, ' ');

                      // Convert to proper case (title case)
                      return withSpaces.replace(/\w\S*/g, (txt) =>
                        txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase()
                      );

                    };

                    // Extract department from the original table name (prefix before first underscore)
                    const department = notification.Tablename.split('_')[0];

                    return (
                      <div className="card mb-2" key={index} style={{ fontSize: '12px' }}>
                        <div className="d-flex align-items-center justify-content-center">
                          {/* Icon Column */}
                          <div className="d-flex justify-content-center" style={{ width: '2%', minWidth: '20px', paddingTop: '8px' }}>
                            {["Rejected a Data", "Rejected a Template"].includes(notification.CompletedActivity) ? (
                              <i className="bi bi-patch-check text-primary small"></i>
                            ) : (
                              <i className="bi bi-patch-check text-primary small"></i>
                            )}
                          </div>

                          {/* Content Column */}
                          <div className="card-body p-2" style={{ width: '98%' }}>
                            <p className="mb-0 small">
                              <strong><span style={{ color: '#366872' }}>{notification.userId}</span></strong>{' '}
                              has{' '}
                              <strong><span style={{ color: '#366872' }}>{notification.CompletedActivity}</span></strong>{' '}
                              (<strong>{formatTableName(notification.Tablename)}</strong>){' '} for {' '}
                              {department}
                            </p>
                          </div>
                        </div>
                      </div>
                    );
                  })
              ) : (
                <p className="text-center small">No notifications available.</p>
              )}
            </Offcanvas.Body>
          </Offcanvas>
        </div>

        <div className="dropdown">
          <a
            className="d-flex align-items-center text-white text-decoration-none dropdown-toggle"
            href="#"
            id="dropdownUser"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            <Avatar userName={userName} />
            <span className="d-none d-md-inline fw-semibold ms-2">{userName}</span>
          </a>

          <ul className={`dropdown-menu dropdown-menu-end rouded-0 shadow border-0 mt-2 ${styles.dropdownMenu}`}
            aria-labelledby="dropdownUser">
            {/* User Info Row */}
            <li
              className={`dropdown-item d-flex align-items-center gap-2 ${styles.dropdownItem}`}
              style={{ fontSize: "12px" }}
            >
              <i className="bi bi-shield-lock"></i>
              <span className="ms-2">Role:</span>

              {originalRole === "Superuser" ? (
                <select
                  className="form-select form-select-sm w-auto border-0 bg-transparent shadow-none"
                  value={userRole}
                  onClick={e => e.stopPropagation()}
                  onChange={e => handleRoleChange(e.target.value)}
                  style={{
                    fontSize: "12px",
                    paddingRight: "1.5rem",
                    paddingLeft: "0.10rem",
                    backgroundPosition: "right 0.3rem center",
                    backgroundSize: "10px",
                  }}
                >
                  <option value="Admin">Admin</option>
                  <option value="Maker">Maker</option>
                  <option value="Checker">Checker</option>
                </select>
              ) : (
                <span className="me-2">{displayRole}</span>
              )}
            </li>
            {/* <li>
              <a className={`dropdown-item ${styles.dropdownItem}`} href="#">
                <i className="bi bi-building me-2"></i> Department: {department}
              </a>
            </li> */}
            <li>
              <a className={`dropdown-item ${styles.dropdownItem}`} href="#">
                <i className="bi bi-building me-2"></i>  Department: {displayDepartment}
              </a>
            </li>
            <li >
              <a className={`dropdown-item ${styles.dropdownItem}`} href="#">
                <i className="bi bi-clock me-2"></i> Last Login: {lastLogin}
              </a>
            </li>

            <li><hr className="dropdown-divider" /></li>

            {/* Logout Option */}
            <li onClick={handleLogout}>
              <a className={`dropdown-item text-danger ${styles.dropdownItem}`} href="#">
                <i className="bi bi-box-arrow-right me-2"></i> Logout
              </a>
            </li>
          </ul>
        </div>

      </div>
    </header>
  );
};

export default Header;
